import React from "react";
import I from "./Icon";
const SB = ({ value, onChange, placeholder = "Search…", style }) => (
  <div className="srch" style={style}>
    <I n="search" s={14} c="#94A3B8" />
    <input value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} />
    {value && <span style={{ cursor: "pointer", color: "#94A3B8", fontSize: 11, flexShrink: 0 }} onClick={() => onChange("")}>✕</span>}
  </div>
);

export default SB;